module.exports = __webpack_public_path__ + "static/media/Guide_Conecta_Pedidos.c1edacb2.pdf";